import { createUseStyles } from 'react-jss';

const calcHeight = (base, size) => `${base * ([4, 5, 6, 7, 8][['xs', 'sm', 'md', 'lg', 'xl'].indexOf(size)])}px`;

const useStyle = createUseStyles((theme) => ({
  buttonBase: (props) => ({
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    position: 'relative',
    cursor: 'pointer',
    fontFamily: 'inherit',
    userSelect: 'none',
    transition: `all ${theme.speed.fast}ms`,
    height: calcHeight(theme.sizes.base, props._size),
    width: (
      props.fixedWidth ? calcHeight(theme.sizes.base, props._size) : (
        props.fullWidth ? '100%' : 'auto'
      )
    ),
    '&[disabled]': {
      cursor: 'not-allowed',
      backgroundColor: theme.colors.gray.normal,
      color: theme.colors.gray.text,
      borderColor: theme.colors.gray.normal,
    },
    '&:focus, &:hover': {
      outline: 'none',
    },
  }),
}));

export default useStyle;
